import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode
} from "react";

interface Notification {
  id: number;
  message: ReactNode; 
  color?: string; 
}

interface NotificationContextType {
  notify: (message: ReactNode, timeout?: number, color?: string) => void;
}

const NotificationContext = createContext<NotificationContextType | null>(null);

export const useNotification = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error("useNotification must be used within NotificationProvider");
  return ctx.notify;
};

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const notify = useCallback((message: ReactNode, timeout: number = 3000, color: string = 'green') => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { id, message, color }]);

    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, timeout);
  }, []);

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <div className="notification-container">
        {notifications.map((n) => (
          <div key={n.id} className="notification" style={{ backgroundColor: n.color }}>
            {n.message}
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};
